import React from 'react';

interface ISingleResultRow {
    key?: number;
    name?: string;
    selectedItems?: any;
    setSelectedItems?: any;
  }


const EntriesFilterRow: React.FC<ISingleResultRow> = ({ key, name, selectedItems, setSelectedItems }) => {
  const handleCheckboxClick = (item: string) => {
    setSelectedItems((prevSelected: any) => {
      const safePrevSelected = Array.isArray(prevSelected) ? prevSelected : [];

      return safePrevSelected?.includes(item) ?
        safePrevSelected.filter((i) => i !== item) :
        [ ...safePrevSelected, item ];
    });
  };

  return (
    <div
      className='full-list-filters-cont-row'
      key={key}
      onClick={() => handleCheckboxClick(name ? name : '')}
      style={{ cursor: 'pointer' }}
    >
      <div className='full-list-filters-cont-row-icon'>
        { selectedItems?.includes(name) ? (
          <div className='full-list-filters-cont-row-icon-item'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
            >
              <path
                d='M10 3L4.5 8.5L2 6'
                stroke='#EFF1F6'
                strokeWidth='1.6666'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
        ) : (
          <div className='full-list-filters-cont-row-icon-item-unselected'></div>
        )}
      </div>
      <div className='full-list-filters-cont-row-text'>{name}</div>
    </div>
  );
};

export default EntriesFilterRow;
